const baseUrl = window?.globalConfig.REACT_APP_API_BASE_URL.replace("<DOMAIN_NM>", window.location.hostname) || process.env.REACT_APP_API_BASE_URL;

// login
export const loginUrl = baseUrl + 'Api/CMSClient/Auth/loginRequest';
export const addCustomer = baseUrl + 'Api/CMSClient/Auth/addCustomerDetail';
export const otpVerify = baseUrl + 'Api/CMSClient/Auth/loginVerify';
export const loginOtpResend = baseUrl + 'Api/CMSClient/Auth/loginOTPResend';
export const logOut = baseUrl + 'Api/CMSClient/Auth/logoutRequest';
export const bankDtl = baseUrl + 'Api/CMSClient/Auth/bankDetail';
export const refreshTkn = baseUrl + 'Api/CMSClient/Auth/reFreshToken';
export const getCaptchaCode = baseUrl + 'Api/CMSClient/Auth/getCaptchaCode';
export const forgotPassword = baseUrl + 'Api/CMSClient/Auth/forgotPassword';
export const forgotPasswordVerify = baseUrl + 'Api/CMSClient/Auth/forgotPasswordVerify';
export const getAuthUserManual = baseUrl + 'Api/CMSClient/Auth/getUserManual';

// profile
export const getProfile = baseUrl + 'Api/CMSClient/Profile/getProfile';
export const updateProfile = baseUrl + 'Api/CMSClient/Profile/updateProfile';

// feedback api's
export const addFeedback = baseUrl + 'Api/CMSClient/Feedback/addFeedback';

// dashboard api's
export const dashboardTicketCount = baseUrl + 'Api/CMSClient/Dashboard/getDashboardCounts';
export const dashboardTickets = baseUrl + 'Api/CMSClient/Dashboard/getDashboardTickets';
export const getUserManual = baseUrl + 'Api/CMSClient/Dashboard/getUserManual';

// get category Dropdown
export const getCategoryDropdown = baseUrl + 'Api/CMSClient/Combo/getCategoryCombo';

// get sub category dropdown
export const getSubCategoryDropdown = baseUrl + 'Api/CMSClient/Combo/getSubCategoryCombo';

// get branch dropdown 
export const getBranchDropdown = baseUrl + 'Api/CMSClient/Combo/getBranchCombo';
export const getTicketTemplateCombo = baseUrl + 'Api/CMSClient/Combo/getTicketTemplateCombo';

// get organization dropdown 
export const getOrganizationCombo = baseUrl + 'Api/CMSClient/Combo/getOrganizationCombo';

// add ticket api 
export const addTicket = baseUrl + 'Api/CMSClient/Ticket/addTicket';

// get Ticket api
export const getTicket = baseUrl + 'Api/CMSClient/Ticket/getTicket';

// get Ticket Details 
export const getTicketDetails = baseUrl + 'Api/CMSClient/Ticket/getTicketDetail';

// get ticken post Details
export const getTicketPost = baseUrl + 'Api/CMSClient/Ticket/getTicketPosts';

// add ticket post details 
export const addTicketPost = baseUrl + 'Api/CMSClient/Ticket/addTicketPost';

// get ticket status dropdown
export const getTicketStatus = baseUrl + 'Api/CMSClient/Combo/getTicketStatusCombo';

// update ticket status
export const updateTicketStatus = baseUrl + 'Api/CMSClient/Ticket/updateTicketStatus';

// downloaded attech file
export const downloadAttechFiles = baseUrl + 'Api/CMSClient/Ticket/ticketAttachmentDownload';
export const getTicketDynamicColumns = baseUrl + 'Api/CMSClient/Combo/getTicketDynamicColumns';

// Ticket feedback
export const addTicketFeedback = baseUrl + 'Api/CMSClient/Feedback/addTicketFeedback';

// Change Password
export const changePassword = baseUrl + 'Api/CMSClient/ChangePassword/changePassword';

export const getArticleList = baseUrl + 'Api/CMSClient/Article/getArticleList';

export const getAnnouncement = baseUrl + 'Api/CMSClient/Announcement/getAnnouncement';
export const getAnnouncementAlert = baseUrl + 'Api/CMSClient/Announcement/getAnnouncementAlert';
export const readAnnouncementAlert = baseUrl + 'Api/CMSClient/Announcement/readAnnouncementAlert';
export const downloadAnnouncement = baseUrl + 'Api/CMSClient/Announcement/downloadAnnouncement';

export const getCircular = baseUrl + 'Api/CMSClient/Circular/getCircular';
export const readCircularAlert = baseUrl + 'Api/CMSClient/Circular/readCircularAlert';
export const downloadCircular = baseUrl + 'Api/CMSClient/Circular/downloadCircular';

export const getNotification = baseUrl + 'Api/CMSClient/Notification/getNotification';
export const getNotificationDetail = baseUrl + 'Api/CMSClient/Notification/getNotificationDetail';

export const addException = baseUrl + 'Api/CMSClient/Exception/addException';


